import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(
  dateStr?: string | Date | number | null,
  fallback = '—',
): string {
  if (!dateStr) return fallback
  const date = typeof dateStr === 'object' ? dateStr : new Date(dateStr)
  if (Number.isNaN(date.getTime())) return fallback
  return date.toLocaleString('th-TH', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
